import { rsqlAnd, rsqlEquals } from '../../lib/rsql'
import type { DashboardFilter } from '../../types/insights'

/**
 * Builds the RSQL clause for the AC12 drill navigation. `ProgramFilingApi.list`
 * (per the IB-45 backend design, §1.5.2) only allow-lists
 * `caseId|programId|currentState|submissionOutcome|createdAt` as RSQL fields —
 * **note for Tech Lead/Backend:** the dashboard filter axes `jurisdiction`,
 * `accountId`, `legalEntityId`, and `fiscalYearId` have no corresponding RSQL
 * field on that endpoint today, so a drill from the jurisdiction/FY or
 * account/legal-entity–scoped tiles can only carry `programId`/`currentState`
 * forward precisely; the rest of the dashboard's active filter narrows what
 * the *tile* shows but not what the drilled list's initial query pre-filters
 * on. This is disclosed, not silently dropped — flagged in the story report.
 */
export function buildDrillRsql(filter: DashboardFilter, overrides: { currentState?: string; programId?: string } = {}): string {
  const currentState = overrides.currentState ?? filter.currentState
  const programId = overrides.programId ?? filter.programId
  return rsqlAnd(
    currentState ? rsqlEquals('currentState', currentState) : null,
    programId ? rsqlEquals('programId', programId) : null,
  )
}
